module.exports = __webpack_public_path__ + "static/media/Property 1=Bạc.627b3657.png";